import { MobileNav } from './mobile-nav'
import { APP_HEADER_CLASS } from './sidebar'
import { UserMenu } from './user-menu'

import type { ReactElement } from 'react'

import { ThemeToggle } from '@/components/shared/theme-toggle'




export function Header(): ReactElement {
  return (
    <header className={APP_HEADER_CLASS}>
      <MobileNav />
      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
